import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';
import { showErrorMessage } from '~/domain/utils';

interface IUpdateCandidateStatusOptions {
  invalidateCache?: boolean;
}

export const useUpdateCandidateStatus = ({
  invalidateCache = true,
}: IUpdateCandidateStatusOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: PermanentJobsService.updateCandidateStatus,
    onError(error) {
      showErrorMessage({ error });
    },
    onSettled(_, error) {
      if (!error && invalidateCache) {
        queryClient.invalidateQueries({ queryKey: ['GET_CANDIDATE_LIST'] });
      }
    },
  });
};
